































































































import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import ShoppingCartActions from '@/components/shopping-cart/ShoppingCartActions.vue';
import RelatedPartsAction from '@/components/related-part/RelatedPartsAction.vue';
import Price from '@/components/price/Price.vue';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import ReplacementPartsAction from '@/components/related-part/ReplacementPartsAction.vue';
import PartSearchCardImage from '@/components/part-search/PartSearchCardImage.vue';
import { localize } from '@/filters/localize';
import { PartDeliveryTimeInformation } from '@/entities/PartDeliveryTimeInformation';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import _ from 'lodash';
import { PartSearchModuleTypes } from '../../store/modules/part-search';

@Component({
    components: {
        ShoppingCartActions,
        RelatedPartsAction,
        LoadingIndicator,
        Price,
        ReplacementPartsAction,
        PartSearchCardImage,
        DeliveryTimeToolTip,
    },
})
export default class PartSearchCard extends Mixins(BaseMixin) {
    @Prop(Object)
    private result!: PartSearchResultDetails;
    @Prop(String)
    private partDetailLink!: string;

    private reloadAvailabilityDebounced: (quantity: number) => void;
    private showAvailability: boolean = true;

    constructor() {
        super();
        this.reloadAvailabilityDebounced = _.debounce(this.reloadAvailability, 500);
    }

    public get fullPartId(): string {
        return this.result.searchResult.id;
    }

    public get hasRelatedParts(): boolean {
        return this.result.searchResult.hasAlternativeParts || this.result.searchResult.hasReplacementParts;
    }

    private get maxAllowedQuantity(): number | undefined {
        if (!this.result.searchResult.isUsedPart) {
            return undefined;
        }

        return this.getAvailableItemCount();
    }

    private onQuantityChanged(quantity: number): void {
        this.reloadAvailabilityDebounced(quantity);
    }

    private onQuantityValid(): void {
        this.showAvailability = true;
    }

    private onQuantityInvalid(): void {
        this.showAvailability = false;
    }

    private reloadAvailability(quantity: number): void {
        const partId = this.result.searchResult.id;
        this.$store.dispatch(PartSearchModuleTypes.actions.reloadPartAvailabilityForPart, {
            partId,
            quantity,
        });
    }

    private getAvailableItemCount(): number {
        if (!this.result.partAvailability || !this.result.partAvailability.stockInfos) {
            return 0;
        }
        return this.result.partAvailability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }
}
